/* eslint-disable react/no-did-update-set-state */
/* eslint-disable no-else-return */
/* eslint-disable class-methods-use-this */
/* eslint-disable jsx-a11y/no-onchange */
/* eslint-disable max-len */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable react/sort-comp */
/* eslint-disable space-before-blocks */
/* eslint-disable object-shorthand */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import sha1 from 'sha1';
import ReCAPTCHA from 'react-google-recaptcha';
import moment from 'utils/moment';
import PulpoField from '../../../pulpo_visualizer/fields/PulpoField';
import close from '../../../icons/closeIcon.svg';
import backarrow from '../../../icons/backarrow.png';
import Panel from '../../../components/panel/Panel';
import Modal from '../../../components/modal';
import Status from '../List/components/Status';
import { renderInfoForType } from '../../../utils/helpers';
import Button from '../../../components/button/button';
import Loading from '../../../components/loading/loading';
import WorkorderStyles from '../../noise_log/forms.module.scss';
import FixedFeilds from '../create/FixedFeilds';
import { S3Uploads, GetFileName } from '../../services';
import { searchUser, fetchDataSourceList } from '../../inspections/redux/actions';
import { fetchCategories, fetchWorkOrderSchema, createLeaseWokrorder, fetchOpenWorkorders, clear } from '../redux/actions';
import { fetchUserProfile } from '../../authentication/redux/actions';
import { isLocal, hostName } from '../../../constants/apiEnv';
import FormSubmitted from '../../forms/components/FormSubmitted';
import MultiColumnGrid from '../../forms/MultiColumnGrid';
import countries from './countries.json';
import styles from '../../../pulpo_visualizer/fields/fields.module.scss';
import styles2 from '../inspections.module.scss';
import styles1 from '../../forms/forms.module.scss';
import LoginForm from './components/LoginForm';
import OTPForm from './components/OTPForm';
import Table from './components/Table';
import gstyles from '../../../styles/general.module.scss';
import userIcon from '../../../images/user.svg';
import defaultFields from '../defaulf_fields.json';

const url = hostName.slice(6);

class MaintenanceCreatePublic extends Component {
  constructor(props) {
    super(props);
    localStorage.setItem('timeFormat', 'hh:mm A');
    localStorage.setItem('dateFormat', 'MM/DD/YYYY');
  this.state = {
    info: {
      report_date: moment().format(),
      attachments: [],
      priority: '',
      global_location: {},
      airfield_location: ''
    },
    captchaError: false,
    answers: {},
    requiredMap: {},
    showFormErrors: false,
    fieldErrors: {
      category_id: true,
      priority: false,
      problem_description: true,
      location: false
    },
    apiStatus: undefined,
    loadingStatus: false,
    showLocationWorkorders: false,
    selectedCountry: 'US',
    formStatusMessage: '',
    publicFormData: {},
    selected: [],
    blurredFields: {
      phone: false,
      password: false,
      isChecked: false,
      code: false
    },
    errors: {
      phoneEmpty: true,
      passwordEmpty: true,
      invalidCredentials: false,
      invalidPassword: false,
      phoneInvalid: false,
      codeEmpty: true
    },
    currentPage: 'Workrder login',
    cognitoCodeError: false,
    cognitoPhoneError: false,
    application: {},
    resendSuccess: false,
    errorMessage: '',
    invalid_phone: false,
    submittedBy: 'contact_info',
    orderNumber: '',
    specificWorkorderStatus: {},
    errorStatusMessage: '',
    userActionPopup: false
  };
  const { match: { params: { id } } } = props;
  localStorage.setItem('portalBackendId', id);
  this.publicUrl = isLocal ? process.env.REACT_APP_BACKEND_PUBLICHOST : `https://apis.${id}${url}/public`;
  }

  firstTime = true;

  recaptchaRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    // grab user from state
    if (props.user.id && !state.info.logged_by.id) {
      return {
        ...state,
        info: {
          ...state.info,
          logged_by: {
            id: props.user.id,
            fullname: props.user.fullname
          }
        }
      };
    }
    if (props.createWorkorderAction && props.createWorkorderAction.success && state.loadingStatus) {
      props.history.push('/maintenance');
      return { ...state, loadingStatus: false };
    }
    return state;
  }

      setUserLoggedIn = (phoneNumber, publicData) => {
          localStorage.setItem('publicUserLoggedIn', 'true');
          localStorage.setItem('publicUserPhone', phoneNumber || '');
          localStorage.setItem('publicUserData', JSON.stringify(publicData || []));
      }

      isUserLoggedIn = () => {
        try {
          return localStorage.getItem('publicUserLoggedIn') === 'true';
        } catch (error) {
          return false;
        }
      }

      getLoggedInUserData = () => {
        if (!this.isUserLoggedIn()) return null;
        try {
          return {
            phone: localStorage.getItem('publicUserPhone') || '',
            publicData: JSON.parse(localStorage.getItem('publicUserData') || '[]')
          };
        } catch (error) {
          return null;
        }
      }

      clearUserLogin = () => {
          localStorage.removeItem('publicUserLoggedIn');
          localStorage.removeItem('publicUserPhone');
          localStorage.removeItem('publicUserData');
 }

  async componentDidMount() {
    const { match: { params: { airportCode } } } = this.props;
        if (this.isUserLoggedIn()) {
          const userData = this.getLoggedInUserData();
          this.setState({
            selected: 'WorkOrderlist',
            publicData: userData.publicData || [],
            phone: userData.phone || '',
            loadingStatus: false
          });
          this.fetchSchema(airportCode);
          return;
        }
        await this.fetchSchema(airportCode);
      }

     fetchSchema = async (airportCode) => {
      try {
        this.setState({ loadingStatus: true });
        await fetch(`${this.publicUrl}/non_airfield/get_schema/${airportCode}`)
          .then(response => response.json())
          .then((data) => {
            let requiredMap = {};
            let fieldErrors = {};
            let conditionalFields = {};
            const attachmentFields = [];
            const categories=data?.maintenance_categories;
            this.setState({
              publicFiledValidations: data.public_attributes||{},
              leaseMaintenance_schema: data,
              requiredMap,
              fieldErrors,
              loadingStatus: false,
              categories,
              attachmentFields,
              conditionalFields,
              apiStatus: false
            });
          });
          if (this.state.leaseMaintenance_schema.detail === 'Requested airport has no public form'){
            let message = 'There was a problem while retrieving the form';
          this.setState({
            message: message,
            apiStatus: true,
            loadingStatus: false
          });
              }
      } catch (e) {
        let message = 'There was a problem while retrieving the form';
        this.setState({
          message: message,
          apiStatus: true,
          loadingStatus: false
        });
      }
    }


  componentDidUpdate(prevprops) {
    const { leaseMaintenance_schema } = this.state;
    const { locationsAction } = this.props;
    if (this.firstTime && leaseMaintenance_schema?.workorder && leaseMaintenance_schema.workorder.id) {
      this.processInspectionForState(leaseMaintenance_schema.workorder, leaseMaintenance_schema?.airport_data);
      this.firstTime = false;
    }
    if (prevprops?.locationsAction !== locationsAction && locationsAction?.success) {
      this.setState({ showLocationWorkorders: true, loadingStatus: false });
    }
  }

  componentWillUnmount() {
    const { actionClear } = this.props;
    actionClear();
  }

  processInspectionForState = (workorder, airport_data) => {
    if (workorder) {
      const { schema } = workorder;
      let { fieldErrors, requiredMap, answers } = this.state;

      schema.fields.forEach((f) => {
        requiredMap = { ...requiredMap,
          [f.id]: f.type==='dataSource' || f.type==='dataSourceMultiLevel'|| f.type === 'user_dropdown' ? false: f.required };
        fieldErrors = { ...fieldErrors,
          [f.id]: f.type==='dataSource' || f.type==='dataSourceMultiLevel' || f.type === 'user_dropdown'? false: f.required };
        if (f.type==='dataSource' || f.type==='dataSourceMultiLevel' || f.type === 'user_dropdown') {
          answers = { ...answers, [f.id]: ' ' };
        }
        if (f?.type === 'time' || f?.type === 'datetime') {
          answers = { ...answers, [f.id]: f?.default === true ? moment().format() : '' };
        }
      });
      if (airport_data?.enable_service_request === true) {
        fieldErrors.location = false;
      } else {
        fieldErrors.location = schema?.default_fields?.default_location?.required || false;
      }
      this.setState({ requiredMap, fieldErrors, answers });
    }
  }

  getData = (newInfo) => {
    this.setState({ publicData: newInfo });
  }

  openModal = () => {
    const { info } = this.state;
    const { match: { params: { airportCode } }, actionFetchOpenWorkorders } = this.props;
    let data;
    if (info.location?.length > 0) {
     data = {
      location: info.location,
      sub_location: info.sub_location
     };
    } else if (Object.keys(info?.global_location)?.length > 0) {
      data = {
        global_location: info.global_location
      };
    }
    this.setState({ loadingStatus: true });
    actionFetchOpenWorkorders(this.publicUrl, data, airportCode);
  }

  closeModal = () => {
    this.setState({ showLocationWorkorders: false });
  }

  handleAnswerChanged = (section, answer, fieldId) => {
    const { publicFiledValidations, leaseMaintenance_schema } = this.state;
    const { user } = this.props;
    if (Object.keys(publicFiledValidations).indexOf(fieldId)>=0){
      let errVal= false;
      if ((answer.trim()==='')){
        errVal= true;
      }
    this.setState({
      publicFiledValidations: {
        ...publicFiledValidations,
        [fieldId]: errVal
      }
    });
  }
    let airfield_location = user.airport?.location?.coordinates ? user.airport.location.coordinates:'';
    if (fieldId === 'location' && section === 'info') {
      let locations = { airfield_location: answer };
      if (typeof (answer) === 'string') {
        if (fieldId === 'location') {
          this.handleFieldErrorChanged(fieldId, !!(answer && answer === ''));
        }
        const get_location = leaseMaintenance_schema?.locations?.filter(loc => loc.name === answer);
        if (get_location.length > 0 && get_location[0].default_location) {
          airfield_location = get_location[0].default_location?.coordinates;
        }
        locations = { airfield_location, location: answer };
      }
      this.setState(prevState => ({
        info: { ...prevState.info, ...locations },
        locationChanged: true
      }));
    } else if (section === 'info' && fieldId === 'sub_location') {
      let locations = { airfield_location: answer };
      if (typeof (answer) === 'string') {
        const get_location = leaseMaintenance_schema?.sub_locations?.filter(loc => loc.name === answer);
        if (get_location.length > 0 && get_location[0].default_sub_location) {
          airfield_location = get_location[0].default_sub_location?.coordinates;
        }
        locations = { airfield_location, sub_location: answer };
      }
      this.setState(prevState => ({
        info: { ...prevState.info, ...locations },
        locationChanged: true
      }));
    } else {
      if (fieldId === 'global_location') {
        this.handleFieldErrorChanged('location', !!(answer && answer === ''));
      }
      this.setState(prevState => ({
        [section]: {
          ...prevState[section],
          [fieldId]: answer
        }
      }));
    }
  }

  handleFieldErrorChanged = (id, value) => {
    this.setState(prevState => ({
      fieldErrors: {
        ...prevState.fieldErrors,
        [id]: value
      }
    }));
  }

  handleSearchForUser = (value) => {
     const { actionSearchUser } = this.props;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      actionSearchUser(value);
    }, 300);
  }

  getFileNames = async (count, airportCode, entity) => {
    const response = await GetFileName.getPublicUploadFileName(count, airportCode, entity);
    return response;
  };

  doS3Upload = async (files, fileIds, entity) => {
    const { match: { params: { id, airportCode } } } = this.props;
    const installation = id;
    const response = await S3Uploads.uploadFiles(
        files,
        fileIds.filename,
        entity,
        installation,
        airportCode
    );
    return response;
  };

  isValidPhoneNumber(input) {
    if (input === '') {
        return true;
    }
    if (!input) {
        return false;
    }
    const phoneNumberPattern = /^(?!\+)[0-9 ()-]+$/;

    if (phoneNumberPattern.test(input)) {
        return true;
    } else {
        return false;
    }
}

handleOpenOtpForm = () => {
  this.setState({ currentPage: 'otpForm', loadingStatus: false });
}

    validateFormFields(inputType, value) {
      let errors = {};
      switch (inputType) {
        case 'phone':
          if (value === '' || value === '+') {
            errors = Object.assign(errors, { phoneEmpty: true, emailInvalid: false });
          }
          if (value !== '+') {
            errors = Object.assign(errors, { phoneEmpty: false, emailInvalid: false });
          }
          break;
        case 'otp':
          if (value !== '') {
            errors = Object.assign(errors, { codeEmpty: false });
          }
          break;
        case 'password':
          errors = Object.assign(errors, { passwordEmpty: value === '' });
          break;
        default:
          break;
      }
      this.setState(prevState => ({
        errors: Object.assign({}, prevState.errors, errors)
      }));
    }

    handleInputChange = (inputType, value) => {
      const { cognitoPhoneError, cognitoCodeError } = this.state || {};
      if (value !== '' && cognitoPhoneError === true) {
        this.setState({ cognitoPhoneError: false });
      } else if (value !== '' && cognitoCodeError === true) {
        this.setState({ cognitoCodeError: false });
      }
      this.setState({
        [inputType]: value,
        invalid_phone: false,
        errorMessage: ''
      }, () => this.validateFormFields(inputType, value));
    }

  isValidPhone(phoneNumber) {
    if (!phoneNumber) return false;
    const digits = phoneNumber.replace(/\D/g, '');
    return digits.length >= 10 && digits.length <= 15;
  }

    handleUser = async (e) => {
      this.setState({ loadingStatus: true, invalid_phone: false, errorMessage: '' });
      const { phone } = this.state;
      if (e) {
        e.preventDefault();
      }
      let phoneNumber = phone;
      phoneNumber = phoneNumber?.[0] + phoneNumber?.slice(1).replace(/[^\d]/g, '');
      const data = {
        phonenumber: phoneNumber
      };
      if (this.isValidPhone(phoneNumber)) {
        try {
        const res = await fetch(`${this.publicUrl}/non_airfield/generate_otp_public_user/`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: { 'Content-Type': 'application/json' }
          });
          const d = await res.json();
          if (!res.ok) {
            this.setState({
              errorMessage: d?.detail || d?.message || 'Something went wrong',
              loadingStatus: false
            });
            throw new Error(d?.detail || d?.message || 'Something went wrong');
          }
          if (res.ok) {
            this.handleSelect('otpForm');
          }
        } catch (error) {
          let message = 'There was a problem while sending the form';
          if (error && error.detail) message = error.detail;
          this.setState({
            message,
            loadingStatus: false,
            cognitoPhoneError: true
          });
        }
      } else {
        this.setState({ invalid_phone: true, loadingStatus: false });
      }
    }

  handleInputBlurred = (inputType) => {
    if (this.state) {
      this.setState(prevState => ({
        blurredFields: Object.assign({}, prevState.blurredFields, {
          [inputType]: true
        })
      }));
    }
  }

  onChangeRememberMe =(event) => {
    this.setState({
      isChecked: event.target.checked
    });
  }

  handleOTPLogin = () => {
    this.setState({ currentPage: 'otpLogin' });
  }

  validateOtpField = () => {
    if (this.state.otp === '') {
      return true;
    }
    return false;
  }

  handleLogin = async (e) => {
    const { otp, phone } = this.state;
    const { match: { params: { airportCode } } } = this.props;
    e.preventDefault();
    this.setState({ loadingStatus: true });
    const isOTPEmpty = this.validateOtpField();
    if (!isOTPEmpty) {
      let phoneNumber = phone;
      phoneNumber = phoneNumber?.[0] + phoneNumber?.slice(1).replace(/[^\d]/g, '');
      localStorage.setItem('phoneNumber', phoneNumber);
      const data = {
        phonenumber: phoneNumber,
        otp: sha1(otp)
      };
      try {
        const res = await fetch(`${this.publicUrl}/non_airfield/authenticate_otp_public_user/${airportCode}`, {
          method: 'POST',
          body: JSON.stringify(data),
          headers: { 'Content-Type': 'application/json' }
        });
        const d = await res.json();
        if (!res.ok) {
          throw new Error(d?.detail || d?.message || 'Something went wrong');
        }
        if (res.ok && res.status === 200) {
          this.setUserLoggedIn(phoneNumber, d?.applications || []);
          this.setState({
            selected: 'WorkOrderlist',
            loadingStatus: false,
            publicData: d?.applications || []
          });
        }
      } catch (error) {
        let message = 'Incorrect otp';
        if (error && error.detail) message = error.detail;
        this.setState({
          message,
          loadingStatus: false,
          cognitoCodeError: true,
          publicData: {
            'applications': []
        }
        });
      }
    } else {
      this.setState(prevState => ({
        errors: Object.assign({}, prevState.error, {
          codeEmpty: true
        }),
        blurredFields: Object.assign({}, prevState.error, {
          code: true
        }),
        cognitoCodeError: false,
        loadingStatus: false
      }));
    }
  }

  handleResendOTP = async (e) => {
    this.handleUser(e);
  };

  create = async () => {
    const { fieldErrors, publicFiledValidations, info, answers, leaseMaintenance_schema, selectedCountry, submittedBy, categories } = this.state;
    const { match: { params: { airportCode } } } = this.props;
    const defaultCheck = leaseMaintenance_schema.workorder.schema.default_fields;
    const maintenanceTitle = leaseMaintenance_schema?.airport_data?.public_nawo_nomenclature?.length > 0
      ? leaseMaintenance_schema?.airport_data?.public_nawo_nomenclature : '';
    const publicField = leaseMaintenance_schema.workorder.schema.fields?.filter(each => each?.disable_for_public);
    info.priority = defaultCheck?.default_priority?.disable_for_public ? null : info.priority;
    info.category_id = defaultCheck?.default_category?.disable_for_public ? null : info.category_id;
    if (info.priority || defaultCheck?.default_priority?.disable_for_public) {
      fieldErrors.priority = false;
    }
    if (info.priority === ''){
      fieldErrors.priority = true;
    }
    if (!info.category_id && !defaultCheck?.default_category?.disable_for_public) {
      fieldErrors.category_id = true;
    } else {
      fieldErrors.category_id = false;
    }
    if ((!leaseMaintenance_schema?.enable_locations_in_public && fieldErrors.location) || defaultCheck?.default_location?.disable_for_public) {
      fieldErrors.location = false;
    }
    const selectedCategory = categories?.find(
      e => Number(e.id) === Number(info?.category_id)
    );

    const hasSubCategories = selectedCategory?.sub_categories?.length > 0;
    // required only if category has subcategories
    if (hasSubCategories) {
      fieldErrors.subcategory = !info.subcategory;
    } else {
      fieldErrors.subcategory = false;
    }

    if (info.airfield_location?.length===0) {
      delete info.airfield_location;
    }
    if (publicFiledValidations.none) delete publicFiledValidations.none;
    if (publicFiledValidations.enable_company_name) delete publicFiledValidations.enable_company_name;
    publicField.forEach((e) => {
      if (answers[e.id] !== undefined){
           answers[e.id] = '';
      }
      if (fieldErrors[e.id] !== undefined){
        fieldErrors[e.id] = false;
     }
    });
    if (publicFiledValidations.nawo_custom_locations_in_public || !publicFiledValidations.nawo_custom_locations_in_public) {
      delete publicFiledValidations.nawo_custom_locations_in_public;
    }
    if (publicFiledValidations.nawo_global_locations_in_public || !publicFiledValidations.nawo_global_locations_in_public) {
      delete publicFiledValidations.nawo_global_locations_in_public;
    }
    if (publicFiledValidations.nawo_categories_in_public || !publicFiledValidations.nawo_categories_in_public) {
      delete publicFiledValidations.nawo_categories_in_public;
    }
    if (publicFiledValidations?.form_title !== undefined) {
      if (publicFiledValidations.form_title?.trim?.()) {
        publicFiledValidations.form_title = false;
      } else {
        delete publicFiledValidations.form_title;
      }
    }
    let noErrors = Object.keys(fieldErrors)
    .every(k => fieldErrors[k] === false);

  const optFields = publicFiledValidations?.optionalFields;

  const filteredKeys = Object.keys(publicFiledValidations)
    .filter(key => key !== 'optionalFields' && !Object.keys(optFields || {}).includes(key));

    const puberr = filteredKeys?.every(k => (publicFiledValidations[k] === false));
      const recaptchaValue = this.recaptchaRef.current?.getValue();
      if (leaseMaintenance_schema?.enable_captcha) {
        if (!recaptchaValue || recaptchaValue?.length === 0) {
          noErrors = false;
          this.setState({ captchaError: true });
        }
      }
      if (noErrors && puberr) {
      this.setState({ loadingStatus: true });
      let number = info?.phone ? info?.phone?.[0] + info?.phone?.slice(1).replace(/[^\d]/g, '') : undefined;
      const data = { ...info, phone: number };
      if (submittedBy === 'anonymous') {
        data.name = null;
        data.last_name = null;
        data.email = null;
        data.phone = null;
        data.anonymous = true;
      }
      data.response = answers;
      const newAttachments = [];
      if (info.attachments && info.attachments.length > 0) {
        info.attachments.forEach((e) => {
          if (!e.id) {
              newAttachments.push(e);
          }
        });
      }
      if (data.subcategory) {
        if (categories.filter(e => Number(e.id) === Number(info.category_id))[0]?.sub_categories?.length === 0) {
          data.subcategory = '';
        }
      }
      if (data.airfield_location) {
        data.airfield_location = JSON.stringify({
          type: 'Point',
          coordinates: data.airfield_location
        });
      }
      if (data.global_location) {
        data.global_locations = { global_location: data.global_location };
        delete data.global_location;
      }
      let fieldIds = '';
      if (newAttachments.length > 0) {
        fieldIds = await this.getFileNames(newAttachments.length, airportCode, 'lease_workorder');
      }
          if (fieldIds){
            data.attachments= [];
            await this.doS3Upload(newAttachments, fieldIds, 'lease_workorder').then(() => {
              fieldIds.filename.forEach((attachmentId) => {
                attachmentId &&data.attachments.push(attachmentId.toString());
              });
            });
            data.airportCode = this.props.match.params.airportCode;
          }
      try {
        await fetch(`${this.publicUrl}/non_airfield/create_maintenance/${airportCode}`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: { 'Content-Type': 'application/json' }
          })
          .then(response => response.json())
          .then((data) => {
            this.setState({
              message: `Your ${maintenanceTitle || 'Work Order'} #${data?.order_number} entry has been submitted successfully.`,
              apiStatus: true,
              loadingStatus: false
            });
          });
      } catch (error) {
        let message = 'There was a problem while submitting the form';
        if (error && error.detail) message = error.detail;
        this.setState({
          message: message,
          apiStatus: true,
          loadingStatus: false
        });
      }
    } else {
      this.setState({ showFormErrors: true });
    }
  }

  cancelWorkorderCreate = () => {
    this.props.history.push('/maintenance');
  }


  handleSelect = (option) => {
    this.setState({ selected: option, loadingStatus: false });
  };

  handleChange = (value) => {
    const { leaseMaintenance_schema } = this.state;
    if (value === 'anonymous') {
      this.setState(prevState => ({
        publicFiledValidations: {
          ...prevState.publicFiledValidations,
          name: false,
          last_name: false,
          email: false,
          phone: false,
          none: true
        },
        submittedBy: value
      }));
    } else {
      this.setState({
        publicFiledValidations: leaseMaintenance_schema?.public_attributes || {},
        submittedBy: value
      });
    }
  }

  handleNumberChange = (value) => {
    this.setState({
      orderNumber: value,
      specificWorkorderStatus: {},
      errorStatusMessage: ''
    });
  }

  handleSearch = async () => {
    const { match: { params: { airportCode } } } = this.props;
    const { orderNumber, leaseMaintenance_schema } = this.state;
    const maintenanceTitle = leaseMaintenance_schema?.airport_data?.public_nawo_nomenclature?.length > 0
      ? leaseMaintenance_schema?.airport_data?.public_nawo_nomenclature : 'workorder';
    if (orderNumber.trim() === '') {
      this.setState({
        errorStatusMessage: `Please add ${maintenanceTitle} ID`
      });
      return;
    }
    try {
      this.setState({ loadingStatus: true });
      const response = await fetch(`${this.publicUrl}/non_airfield/get_status/${orderNumber}/${airportCode}`);
      if (response.status === 200) {
        const data = await response.json();
        this.setState({
          specificWorkorderStatus: data?.data || {},
          loadingStatus: false,
          errorStatusMessage: ''
        });
      } else if (response.status === 400) {
        const data = await response.json();
        let message = `There was a problem while retrieving the ${maintenanceTitle}`;
        this.setState({
          errorStatusMessage: data?.message || message,
          loadingStatus: false
        });
      } else {
        this.setState({
          errorStatusMessage: `There was a problem while retrieving the ${maintenanceTitle}`,
          loadingStatus: false
        });
      }
    } catch (e) {
      let message = `There was a problem while retrieving the ${maintenanceTitle}`;
      this.setState({
        errorStatusMessage: e?.message || message,
        loadingStatus: false
      });
    }
  }

  handleAddWorkorder = (user, type) => {
    const { leaseMaintenance_schema } = this.state;
    const fieldValidation = {};
    if (user?.public_info?.name && user?.public_info?.name?.trim() !== '' && leaseMaintenance_schema?.public_attributes?.name) {
      this.handleAnswerChanged('info', user?.public_info?.name, 'name');
      fieldValidation.name = false;
    }
    if (user?.public_info?.last_name && user?.public_info?.last_name?.trim() !== '' && leaseMaintenance_schema?.public_attributes?.last_name) {
      this.handleAnswerChanged('info', user?.public_info?.last_name, 'last_name');
      fieldValidation.last_name = false;
    }
    if (user?.public_info?.email && user?.public_info?.email?.trim() !== '' && leaseMaintenance_schema?.public_attributes?.email) {
      this.handleAnswerChanged('info', user?.public_info?.email, 'email');
      fieldValidation.email = false;
    }
    if (user?.public_info?.phone && user?.public_info?.phone?.trim() !== '' && leaseMaintenance_schema?.public_attributes?.phone) {
      this.handleAnswerChanged('info', user?.public_info?.phone, 'phone');
      fieldValidation.phone = false;
    }
    this.setState(prevState => ({
      publicFiledValidations: {
        ...prevState.publicFiledValidations,
        ...fieldValidation
      },
      selected: type
    }));
  }

  handleLogOut = (createLabel) => {
    const { leaseMaintenance_schema } = this.state;
    this.clearUserLogin();
    this.setState({
      publicFiledValidations: leaseMaintenance_schema?.public_attributes || {},
      userActionPopup: false,
      selected: createLabel,
      publicData: [],
      info: {
        report_date: moment().format(),
        attachments: [],
        priority: '',
        global_location: {},
        airfield_location: ''
      },
      phone: '',
      otp: ''
    });
  }

    handleBackButton = () => {
      const { selected, leaseMaintenance_schema } = this.state;
      const maintenanceTitle = leaseMaintenance_schema?.airport_data?.public_nawo_nomenclature?.length > 0
        ? leaseMaintenance_schema?.airport_data?.public_nawo_nomenclature : 'Work Order';
      const statusLabel = `View My ${maintenanceTitle}`;
      const trackLabel = `Track ${maintenanceTitle} by ID`;
      const createLabel = `Create ${maintenanceTitle}`;

      if (selected === 'otpForm') {
        this.setState({
          selected: statusLabel,
          otp: '',
          cognitoCodeError: false,
          errorMessage: ''
        });
      } else if (selected === statusLabel || selected === trackLabel) {
        this.handleLogOut(createLabel);
      } else if (selected === 'WorkOrderlist') {
        this.setState({
          selected: statusLabel,
          publicData: []
        });
      }
    }

    shouldShowBackButton = () => {
      const { selected, leaseMaintenance_schema } = this.state;
      const maintenanceTitle = leaseMaintenance_schema?.airport_data?.public_nawo_nomenclature?.length > 0
        ? leaseMaintenance_schema?.airport_data?.public_nawo_nomenclature : 'Work Order';
      const statusLabel = `View My ${maintenanceTitle}`;
      const trackLabel = `Track ${maintenanceTitle} by ID`;

      return selected === 'otpForm' || selected === statusLabel || selected === trackLabel;
    }

  render() {
    const { fieldErrors, userlist, translations, user, allProperties, match: { params: { id, airportCode } }, openWorkOrders } = this.props;
    const { info, showFormErrors, requiredMap, loadingStatus, leaseMaintenance_schema,
      categories, message, apiStatus, answers, locationChanged, captchaError, selectedCountry,
      selected, blurredFields, cognitoCodeError, cognitoPhoneError, application, resendSuccess,
      isChecked, phone, password, errors, otp, publicData, errorMessage, invalid_phone, showLocationWorkorders, submittedBy,
      specificWorkorderStatus, errorStatusMessage, userActionPopup } = this.state;
    const translationMap = translations ? translations[user.language] : {};
    const maintenanceTitle = leaseMaintenance_schema?.airport_data?.public_nawo_nomenclature?.length > 0
      ? leaseMaintenance_schema?.airport_data?.public_nawo_nomenclature : '';
  const isLoggedIn = this.isUserLoggedIn();
    const baseTitle = maintenanceTitle || 'Work Order';
    const createLabel = `Create ${baseTitle}`;
    const statusLabel = `View My ${baseTitle}`;
    const trackLabel = `Track ${baseTitle} by ID`;
  let actualSelected = selected;

    if (isLoggedIn && selected !== 'WorkOrderlist' && selected !== createLabel) {
          actualSelected = 'WorkOrderlist';
        if (selected !== 'WorkOrderlist') {
          setTimeout(() => {
            const userData = this.getLoggedInUserData();
            this.setState({
              selected: 'WorkOrderlist',
              publicData: userData.publicData || [],
              phone: userData.phone || ''
            });
          }, 0);
        }
      }
    if (!isLoggedIn && selected === 'WorkOrderlist') {
    const label = `View My ${maintenanceTitle || 'Work Order'}`;
    actualSelected = label;

    setTimeout(() => {
      this.setState({
        selected: label,
        publicData: []
      });
    }, 0);
    }
    let default_fields = [];
    defaultFields.default_fields.forEach((eachDefaultField) => {
      default_fields.push(eachDefaultField?.id);
    });
    let fieldsCheck = (leaseMaintenance_schema?.workorder?.schema?.ordering?.length > 0
      ? leaseMaintenance_schema?.workorder?.schema?.ordering : default_fields);
    const filterGlobalLocations = leaseMaintenance_schema?.nawo_location
      ?.filter(location => leaseMaintenance_schema?.public_attributes?.nawo_global_locations_in_public
      ?.some(publicLocation => publicLocation?.value === location?.id));
    const filterCustomLocations = leaseMaintenance_schema?.locations
      ?.filter(location => leaseMaintenance_schema?.public_attributes?.nawo_custom_locations_in_public
      ?.some(publicLocation => publicLocation?.value === location?.id));
    const publicStatus = leaseMaintenance_schema?.enable_in_public_form_phone_no;
     const maintenanceButton = leaseMaintenance_schema?.airport_data?.public_nawo_nomenclature?.length > 0
      ? leaseMaintenance_schema?.airport_data?.public_nawo_nomenclature : '';
    let loginUserInfo = {};
    if (publicData?.length > 0) {
      loginUserInfo = publicData.find(
        item => (item.public_info && item.public_info.name && typeof item.public_info.name === 'string' && item.public_info.name.trim() !== '')
          || (item.public_info && item.public_info.last_name && typeof item.public_info.last_name === 'string' && item.public_info.last_name.trim() !== '')
      );
    }
    if (loginUserInfo === null || loginUserInfo === undefined) {
      loginUserInfo = {};
    }
    const options = [statusLabel, trackLabel];
    let formToRender;
    let statusValue;
    if (specificWorkorderStatus?.status === 'Cancel') {
      statusValue = 'Cancelled';
    } else if (specificWorkorderStatus?.status === 12) {
      statusValue = specificWorkorderStatus;
    } else {
      statusValue = specificWorkorderStatus?.status;
    }
    if (publicStatus) {
      if (selected === statusLabel) {
        formToRender = (
          <LoginForm
          handleInputChange={this.handleInputChange}
          handleSignIn={this.handleUser}
          errors={errors}
            errorMessage={errorMessage}
            invalid_phone={invalid_phone}
            url={url}
            blurredFields={blurredFields}
            handleInputBlurred={this.handleInputBlurred}
            onChangeRememberMe={this.onChangeRememberMe}
            isRemember={isChecked}
            phone={phone}
            password={password}
            handleForgotPassword={this.handleForgotPassword}
            handleOTPLogin={this.handleOTPLogin}
            cognitoPhoneError={cognitoPhoneError}
            application={application}
            />);
          } else if (selected === 'otpForm') {
          formToRender = (
          <OTPForm
            handleInputChange={this.handleInputChange}
            errors={errors}
            blurredFields={blurredFields}
            handleInputBlurred={this.handleInputBlurred}
            cognitoCodeError={cognitoCodeError}
            otp={otp}
            handleLogin={this.handleLogin}
            handleResendOTP={this.handleUser}
            resendSuccess={resendSuccess}
          />);
          } else if (selected === 'WorkOrderlist') {
          formToRender = (
            <div className={styles2.container}>
              <div className={styles.addButton}>
              <Button translationID="maintenance.start.title"
                defaultText={`Create ${maintenanceButton || 'Work Order'}`}
                translationValues={{ maintenanceTitle: maintenanceButton || 'Work Order' }}
                onClick={() => { this.handleAddWorkorder(loginUserInfo, createLabel); }}
              />
              </div>
              <Table
                baseTitle={baseTitle}
                info={publicData || []}
                airportCode={airportCode}
                Id={id}
                getData={this.getData}
                enable_service_request={leaseMaintenance_schema?.airport_data?.enable_service_request === true}
              />
            </div>
          );
          } else if (selected === trackLabel) {
            formToRender = (
              <div className={styles.searchContainer} style={{ height: 'fit-content', width: 'fit-content', minWidth: '50%', minHeight: '200px' }}>
                <div className={styles.inputField}>
                  <input
                    type="text"
                    id="workorder"
                    name="workorder"
                    className={styles.input}
                    placeholder={`Enter ${baseTitle} ID`}
                    onChange={e => this.handleNumberChange(e?.target?.value)}
                  />
                  <div>
                    <Button action="secondary" onClick={() => this.handleSearch()}
                      translationID="translation.search"
                      defaultText="Search"
                      className={styles.searchButton}
                    />
                  </div>
                </div>
                <div>
                  {Object.keys(specificWorkorderStatus)?.length > 0 && (
                    <div className={gstyles.responsiveTable}>

                    <table className={gstyles.table} style={{ marginTop: '10px' }}>
                      <thead>
                        <tr>
                          <th>
                            <FormattedMessage id="workorder.detail.request.workorder" defaultMessage={`${baseTitle} #`} />
                          </th>
                          <th>
                            <FormattedMessage id="job.settings.type_name" defaultMessage="Date" />
                          </th>
                          <th>
                            <FormattedMessage id="workorders.list.table.status" defaultMessage="Status" />
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{specificWorkorderStatus?.order_number}</td>
                          <td>{renderInfoForType({ 'type': 'datetime' }, specificWorkorderStatus?.report_date, null, null)}</td>
                          <td>
                          <Status item={statusValue} />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    </div>
                  )}
                  {errorStatusMessage && (
                    <span className={styles.errorStatusMsg}>
                      {errorStatusMessage}
                    </span>
                  )}
                </div>
      <div className={gstyles.mobileCards}>
          {Object.keys(specificWorkorderStatus || {})?.length > 0 && (
            <div key={specificWorkorderStatus?.order_number} className={gstyles.tableCard}>
              <div className={gstyles.cardRow}>
                <div className={gstyles.column}>
                  <div className={gstyles.cardLabel}>
                    <FormattedMessage
                      id="workorder.detail.request.workorder"
                      defaultMessage={`${baseTitle} #`}
                    />
                  </div>
                  <div className={gstyles.cardValue}>
                    {specificWorkorderStatus?.order_number}
                  </div>
                </div>
                <div className={gstyles.column}>
                  <div className={gstyles.cardLabel}>
                    <FormattedMessage
                      id="job.settings.type_name"
                      defaultMessage="Date"
                    />
                  </div>
                  <div className={gstyles.cardValue}>
                    {renderInfoForType(
                      { type: 'datetime' },
                      specificWorkorderStatus?.report_date,
                      null,
                      null
                    )}
                  </div>
                </div>
              </div>

              <div className={gstyles.divider} />

                <div className={gstyles.cardRow}>
                  <div className={gstyles.column}>
                    <div className={gstyles.cardLabel}>
                      <FormattedMessage
                        id="workorders.list.table.status"
                        defaultMessage="Status"
                      />
                    </div>
                    <div className={gstyles.cardValue}>
                      <Status
                        item={
                          specificWorkorderStatus?.status === 'Cancel'
                            ? 'Cancelled'
                            : specificWorkorderStatus?.status
                        }
                      />
                    </div>
                  </div>
                </div>
            </div>
          )}
      </div>

              </div>
            );
          }
        }

        const formBlock = (
          <div className={WorkorderStyles.details}>
              <div className={styles.userType}>
                                <div className={styles.check}>
                                    <input
                                      name="question"
                                      id="contact_info"
                                      type="radio"
                                      onChange={() => this.handleChange('contact_info')}
                                      value
                                      defaultChecked={submittedBy === 'contact_info'}
                                    />
                                     &nbsp;&nbsp;
                                    <FormattedMessage id="sms.new.contactInfo" defaultMessage="Share my Contact Information" />
                                </div>

                                  <div className={styles.check}>
                                        <input
                                            name="question"
                                            id="is_anonymous"
                                            type="radio"
                                              onChange={() => this.handleChange('anonymous')}
                                              value
                                              defaultChecked={submittedBy === 'anonymous'}
                                            />
                                            &nbsp;&nbsp;
                                      <FormattedMessage id="sms.new.anonymous_check" defaultMessage="Remain Anonymous" />
                                  </div>
              </div>

                {submittedBy === 'contact_info' && (
                  <div className={WorkorderStyles.details_form}>
                    {leaseMaintenance_schema?.public_attributes?.name && (
                      <PulpoField key="name" id="name" type="string" title="Name"
                        translationID="noise_log.complete.name"
                        handleValueChange={(a, b) => this.handleAnswerChanged('info', a, b)}
                        answer={info.name}
                        isRequired={!leaseMaintenance_schema?.public_attributes?.optionalFields?.name === true}
                        showFieldErrors={showFormErrors}
                        handleFieldErrorChanged={this.handleFieldErrorChanged}
                        customStyles={{ flex: '0 1 100%' }}
                      />
                    )}
                    {leaseMaintenance_schema?.public_attributes?.last_name && (
                      <PulpoField key="last_name" id="last_name" type="string" title="Last Name"
                        translationID="forms.complete.last_name"
                        handleValueChange={(a, b) => this.handleAnswerChanged('info', a, b)}
                        answer={info.last_name}
                        isRequired={!leaseMaintenance_schema?.public_attributes?.optionalFields?.last_name === true}
                        showFieldErrors={showFormErrors}
                        handleFieldErrorChanged={this.handleFieldErrorChanged}
                        customStyles={{ flex: '0 1 100%' }}
                      />
                    )}
                    {leaseMaintenance_schema?.public_attributes?.email && (
                      <PulpoField key="email" id="email" type="string" title="Email"
                        translationID="forms.complete.email"
                        handleValueChange={(a, b) => this.handleAnswerChanged('info', a, b)}
                        answer={info.email}
                        isRequired={!leaseMaintenance_schema?.public_attributes?.optionalFields?.email === true}
                        showFieldErrors={showFormErrors}
                        handleFieldErrorChanged={this.handleFieldErrorChanged}
                        customStyles={{ flex: '0 1 100%' }}
                      />
                    )}
                    {leaseMaintenance_schema?.public_attributes?.phone && (
                      <PulpoField key="phone" id="phone" type="telephone" title="Phone"
                        translationID="profile.phone"
                        handleValueChange={(a, b) => this.handleAnswerChanged('info', a, b)}
                        answer={info.phone}
                        isRequired={!leaseMaintenance_schema?.public_attributes?.optionalFields?.phone === true}
                        showFieldErrors={showFormErrors}
                        handleFieldErrorChanged={this.handleFieldErrorChanged}
                        customStyles={{ flex: '0 1 100%' }}
                      />
                    )}
                  </div>
                )}
                <div className={WorkorderStyles.details_form} style={{ marginTop: '0px' }}>
                  {fieldsCheck?.map(eachfield => (
                    <>
                      {categories && (
                        <FixedFeilds
                          info={info}
                          translation={translationMap}
                          userlist={userlist}
                          allProperties={allProperties}
                          categories={categories}
                          leaseMaintenance_schema={leaseMaintenance_schema}
                          searchForUser={this.handleSearchForUser}
                          handleAnswerChanged={this.handleAnswerChanged}
                          handleFieldErrorChanged={this.handleFieldErrorChanged}
                          showFormErrors={showFormErrors}
                          public_form
                          eachfield={eachfield}
                          user={user}
                          locationChanged={locationChanged}
                          changeLocationChangedStatus={() => { this.setState({ locationChanged: false }); }}
                          global_locations={filterGlobalLocations}
                          locations={filterCustomLocations}
                          sub_locations={leaseMaintenance_schema?.sub_locations}
                          map_view={leaseMaintenance_schema?.map_view}
                          enable_locations_in_public={leaseMaintenance_schema?.enable_locations_in_public}
                          location_attachments={leaseMaintenance_schema?.location_attachments}
                          defaultLocation={leaseMaintenance_schema?.airport_data?.location?.coordinates}
                          map={{ map_style: leaseMaintenance_schema?.airport_data?.map_style,
                            mapbox_style: leaseMaintenance_schema?.airport_data?.mapbox_style
                          }}
                          nawoIcon={leaseMaintenance_schema?.airport_data?.nwo_icon}
                        />
                      )}
                      {(info?.location?.length > 0 || Object.keys(info?.global_location || {})?.length > 0) && eachfield === 'default_location' && (
                        <div>
                          <span>
                            <Button
                              action="transparent"
                              translationID="workorder.airfield.create.view_existing_workorders"
                              defaultText="View existing requests related to selected location"
                              className={styles.btnTextLink}
                              onClick={this.openModal}
                            />
                          </span>
                        </div>
                      )}
                      {Object.keys(requiredMap).length > 0 && leaseMaintenance_schema.workorder.schema.fields.map(field => (
                        field.type !== 'dataSource' && field.type !== 'dataSourceMultiLevel' && !field?.disable_for_public && field.id === eachfield && (
                          <>
                            {field.type !== 'multi_field' && field.type !== 'user_dropdown' && field?.type !== 'duration'
                              &&<PulpoField key={field.id} {...field}
                              translation={translationMap && translationMap[field.title]}
                              handleValueChange={(a, b) => this.handleAnswerChanged('answers', a, b)}
                              isRequired={field.disable_for_public ? false : requiredMap[field.id]}
                              answer={answers[field.id]}
                              showFieldErrors={field.required && showFormErrors}
                              handleFieldErrorChanged={this.handleFieldErrorChanged}
                              disabled={field.disable_for_public}
                              onlyTime={field.type === 'time'}
                              noDefault={field?.default !== true}
                              allFields={leaseMaintenance_schema?.workorder?.schema?.fields}
                              answers={Object.assign({}, answers, info)}
                              customStyles={{ flex: '0 1 100%' }}

                              />
                            }
                            {field.type === 'multi_field' && (
                            <MultiColumnGrid
                              currentField={field}
                              handleAnswerChanged={(a, b) => this.handleAnswerChanged('answers', a, b)}
                              answers={answers}
                              all_fields={leaseMaintenance_schema?.workorder?.schema?.fields}
                              showFormErrors={showFormErrors}
                              handleFieldErrorChanged={this.handleFieldErrorChanged}
                              customStyles={{ flex: '0 1 100%' }}
                              isPublic

                            />)}
                            {field.type === 'duration' && (
                              <PulpoField
                                key={field.id}
                                {...field}
                                translation={translationMap && translationMap[field.title]}
                                handleValueChange={(a, b) => this.handleAnswerChanged('answers', a, b)}
                                isRequired={requiredMap[field.id]}
                                answer={answers[field.id]}
                                showFieldErrors={showFormErrors}
                                handleFieldErrorChanged={this.handleFieldErrorChanged}
                                type={field.type}
                                answers={Object.assign({}, answers, info)}
                                customStyles={{ flex: '0 1 100%' }}
                              />
                            )}
                          </>
                      )))}
                    </>
                  ))}
                </div>
                  <div className={WorkorderStyles.details_form}>
                  {leaseMaintenance_schema?.enable_captcha
                  && <div>
                  <ReCAPTCHA
                    ref={this.recaptchaRef}
                    sitekey={process.env.REACT_APP_RECAPTCHA_TOKEN}
                  />
                  {captchaError && (
                    <div className={WorkorderStyles.captchaError}>
                      <FormattedMessage id="sms.form.captcha_error" defaultMessage="Captcha is not Checked" />
                    </div>
                  )}
                     </div>}
                  </div>
                <div className={`${WorkorderStyles.footer}`}>
                  <Button action="secondary" onClick={this.create}
                    translationID="form.submit_form"
                    defaultText="Submit Form"
                  />
                  <span>
                    <a href="https://www.aerosimple.com" target="_blank" rel="noopener noreferrer" className={WorkorderStyles.formAnchor}>
                      Powered by Aerosimple
                    </a>
                  </span>
                </div>
          </div>
       );

    return (
    <>
      {loadingStatus && (<Loading loadingStatus={loadingStatus} />)}
      {!apiStatus && leaseMaintenance_schema && Object.keys(leaseMaintenance_schema).length > 0 && (
        <>
             <div className={styles.airportContainer}
                style={selected === statusLabel || selected === trackLabel || selected === 'otpForm'? { marginBottom: '0px' }: {}}>

                <div className={`${WorkorderStyles.title} ${WorkorderStyles.imgTitle}`}>
                  <img src={leaseMaintenance_schema?.airport_data?.image} alt="" className={styles.airportlogo} />
                  <div>{leaseMaintenance_schema?.airport_data?.name}</div>
                </div>
               {publicStatus && actualSelected !== statusLabel && actualSelected !== trackLabel && actualSelected !== 'otpForm' && actualSelected !== 'WorkOrderlist' && Object.keys(loginUserInfo)?.length === 0 ? (
                  <div className={styles1.navBarSty}>
                    <div className={styles.selector_container}>
                      <div className={styles.option_group}>
                        {options?.map(option => (
                          <div
                            key={option}
                            className={` ${styles.option} ${selected === option || ((selected === 'WorkOrderlist' || selected === 'otpForm') && option === statusLabel) ? styles.selected : ''}`}
                            onClick={() => this.handleSelect(option)}
                            onKeyPress={() => { this.handleSelect(option); }}
                            role="button"
                            tabIndex="0"
                          >
                            <p>{option}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ) : (
                  (selected === 'WorkOrderlist' || selected === createLabel) && loginUserInfo && (
                   <div className={styles.loginUser}>
                      <img src={userIcon} alt="" className={styles.userIcon} />
                      <span
                        onClick={() => this.setState(prevState => ({ userActionPopup: !prevState.userActionPopup }))}
                        onKeyPress={() => this.setState(prevState => ({ userActionPopup: !prevState.userActionPopup }))}
                        role="button"
                        tabIndex={0}
                        className={styles.userName}
                      >
                        <span className={styles.userInitial}>
                          {loginUserInfo?.public_info?.name?.charAt(0)?.toUpperCase() || loginUserInfo?.public_info?.last_name?.charAt(0)?.toUpperCase() || 'U'}
                        </span>
                        <span className={styles.userNameText}>
                          {loginUserInfo?.public_info?.name || loginUserInfo?.public_info?.last_name || 'User'}
                        </span>
                      </span>
                      {userActionPopup && (
                        <ul className={styles.userDropdown}>
                          <li
                          className={styles.userInfoItem}
                          >
                             {loginUserInfo?.public_info?.name || loginUserInfo?.public_info?.last_name || 'User'}
                          </li>
                          <li
                            onClick={() => this.handleLogOut(createLabel)}
                            onKeyPress={() => this.handleLogOut(createLabel)}
                            aria-hidden="true"
                          >
                            Logout
                          </li>
                        </ul>
                      )}
                   </div>
                  )
                )}
             </div>
                  {this.shouldShowBackButton() && (
                    <div className={styles1.backButtonContainer}
                    role="presentation"
                    onClick={this.handleBackButton}>
                    <img src={backarrow} alt="backArrowIcon" width={20} height={20} />
                    </div>
                  )}
        <div className={!maintenanceTitle?WorkorderStyles.container:WorkorderStyles.containerDynamicTitle}>
          {(!publicStatus || actualSelected === createLabel || Array.isArray(actualSelected)) && !isLoggedIn && (
          <Panel
            title="maintenance.start.heading"
            defaultTitle={`Create ${maintenanceTitle || 'Work Order'}`}
            translationValues={{ maintenanceTitle: maintenanceTitle || 'Work Order' }}
          >
            {formBlock}
          </Panel>
        )}

        {isLoggedIn && selected === createLabel && (
          <Modal showIn onClose={() => this.handleSelect('WorkOrderlist')} contentStyles={{ overflowX: 'auto', height: '70%', width: 'fit-content' }}
        >
            <Panel
              title="maintenance.start.heading"
              defaultTitle={`Create ${maintenanceTitle || 'Work Order'}`}
              translationValues={{ maintenanceTitle: maintenanceTitle || 'Work Order' }}
            >
              {formBlock}
            </Panel>
          </Modal>
        )}
          {formToRender}
        </div>
        </>
      )}
      {apiStatus && (
        <div className="container">
          <FormSubmitted name={leaseMaintenance_schema && leaseMaintenance_schema.title}
            message={message} logo={leaseMaintenance_schema?.airport_data?.image}
          />
        </div>
      )}
      <Modal
          showIn={showLocationWorkorders}
          onClose={this.closeModal}
          width="626px"
          minHeight="auto"
        >
            <div className={styles.relativeModal}>
              <div className={styles.modalTitle}>
                <FormattedMessage
                  className={styles.runwayName}
                  id="workorder.custom_field.related_workorders"
                  defaultMessage={`Related ${maintenanceTitle || 'Workorders'}`}
                />
                <div
                  className={styles.closeIcon}
                  role="presentation"
                  onClick={this.closeModal}
                >
                  <img src={close} alt="closeIcon" />
                </div>
              </div>
              <div style={{ maxHeight: '390px', overflowX: 'scroll' }}>
                <table className={`${styles.table} ${styles.evenWidth}`}>
                  <thead style={{ lineHeight: '26px' }}>
                    <tr style={{ borderBottom: '1px solid #e6eaee', borderTop: '1px solid #e6eaee' }}>
                      <th style={{ width: '25%', textAlignLast: 'center' }}>
                        <FormattedMessage
                          id="forms.savedraft.date"
                          defaultMessage="Date"
                        />
                      </th>
                      <th style={{ width: '35%', textAlignLast: 'center', marginLeft: '10px' }}>
                        <FormattedMessage
                          id="workorder.settings.problem_description"
                          defaultMessage="Problem description"
                        />
                      </th>
                      <th style={{ width: '30%', textAlignLast: 'center' }}>
                        <FormattedMessage
                          id="noise_log.settings.tabstatus"
                          defaultMessage="Status"
                        />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {openWorkOrders?.data?.map(workorder => (
                      <tr style={{ borderBottom: '1px solid #e6eaee' }}>
                        <td style={{ textAlignLast: 'center' }}>{renderInfoForType({ 'type': 'date' }, workorder.report_date, null, null)}</td>
                        <td style={{ textAlignLast: 'center', marginLeft: '10px' }}>{workorder?.problem_description}</td>
                        <td style={{ textAlignLast: 'center' }}>
                          <Status item={workorder?.status} />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

            </div>
      </Modal>
    </>
    );
  }
}

MaintenanceCreatePublic.propTypes = {
  history: PropTypes.shape({}).isRequired,
  actionFetchCategories: PropTypes.func.isRequired,
  actionCreate: PropTypes.func.isRequired,
  actionClear: PropTypes.func.isRequired,
  userlist: PropTypes.arrayOf(PropTypes.shape({}))
};

MaintenanceCreatePublic.defaultProps = {
  userlist: []
};
const mapStateToProps = state => ({
  user: state.auth.profile,
  userlist: state.inspection.userlist,
  translations: state.auth.translations,
  allCategories: state.lease.allCategories,
  // leaseMaintenance_schema: state.lease.leaseMaintenance_schema,
  allDataSources: state.inspection.allDataSources,
  createWorkorderAction: state.lease.createWorkorderAction,
  allProperties: state.lease.allProperties,
  locationsAction: state.lease.locationsAction,
  openWorkOrders: state.lease.openWorkOrders
});

const mapDispatchToProps = dispatch => ({
  actionSearchUser: (query) => {
    dispatch(searchUser(query));
  },
  actionFetchCategories: () => {
    dispatch(fetchCategories());
  },
  actionFetchSchema: () => {
    dispatch(fetchWorkOrderSchema());
  },
  fetchDataSources: () => {
    dispatch(fetchDataSourceList());
  },
  actionCreate: (data) => {
    dispatch(createLeaseWokrorder(data));
  },
  actionClear: () => {
    dispatch(clear());
  },
  actionFetchProfile: () => {
    dispatch(fetchUserProfile());
  },
  actionFetchOpenWorkorders: (publicUrl, data, airportCode) => {
    dispatch(fetchOpenWorkorders(publicUrl, data, airportCode));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(MaintenanceCreatePublic);
